<template>
  <div class="section-panel text-center">
    <div class="title">
      <h3>{{$t('settings.title')}}</h3>
    </div>
    <el-container style="border: 1px solid #eee">
        <el-aside>
          <el-menu :default-active="idxActive" @select="setItem2">
            <el-menu-item index="1" v-permission="['ACCESS_PROJECT']" class="text-left">
              <template slot="title">
                <i class="el-icon-suitcase"></i> {{$t('settings.projects')}}
              </template>
            </el-menu-item>
            <el-menu-item index="2" v-permission="['ACCESS_ROLES']" class="text-left">
              <template slot="title"><i class="el-icon-key"></i>{{$t('settings.roles')}}</template>
            </el-menu-item>
            <el-menu-item index="3" v-permission="['ACCESS_USERS']" class="text-left">
              <template slot="title"><i class="el-icon-user"></i>{{$t('settings.users')}}</template>
            </el-menu-item>
            <el-menu-item index="4" v-permission="['ACCESS_CONFIGURATIONS']" class="text-left">
              <template slot="title"><i class="el-icon-setting"></i>{{$t('settings.configs')}}</template>
            </el-menu-item>
          </el-menu>
        </el-aside>
        
        <el-container>
          <el-main>
            <div v-if="active=='projects'" v-permission="['ACCESS_PROJECT']">
              <projects-table></projects-table>
            </div>

            <div v-if="active=='users'" v-permission="['ACCESS_USERS']">
              <master-table :title="$t('settings.users')" :resource="active">
              </master-table>
            </div>

            <div v-if="active=='roles'" v-permission="['ACCESS_ROLES']">
              <master-table :title="$t('settings.roles')" :resource="active">
              </master-table>
            </div>

            <div v-if="active=='configurations'" v-permission="['ACCESS_CONFIGURATIONS']">
              <master-table :title="$t('settings.configs')" :resource="active">
              </master-table>
            </div>
          </el-main>
        </el-container>
      </el-container>
  </div>
</template>
<script>
import { Card, FormGroupInput, Button, Alert, Switch, Checkbox } from '@/components';
import { MessageBox, Message, Main, Header, MenuItem, Aside, Menu, MenuItemGroup, Container } from 'element-ui';
import MasterTable from '../../pages/components/MasterTable.vue';
import ProjectsTable from '../../pages/components/ProjectsTable.vue';

export default {
  name: 'settings',
  components: {
    Card,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    [Checkbox.name]: Checkbox,  
    [Switch.name]: Switch,
    Alert,
    [Container.name]: Container,
    [Main.name]: Main,
    [Header.name]: Header,
    [MenuItem.name]: MenuItem,
    [Aside.name]: Aside,
    [Menu.name]: Menu,
    [MenuItemGroup.name]: MenuItemGroup,
    MasterTable,
    ProjectsTable
  },
  mounted() {
    this.active = 'projects'
    if (this.$route.query.active) {
      this.setItem(this.$route.query.active)
    }
  },
  data() {
    return {
        loading: false,
        error: null,
        success: null,
        active: this.$route.query.active ? this.$route.query.active : '',
        idxActive: '1'
    }
  },
  methods: {
    setItem (item) {
      switch (item) {
        case "projects":
          this.idxActive = '1'
        break;
        case "roles":
          this.idxActive = '2'
        break;
        case "users":
          this.idxActive = '3'
        break;
        case "configurations":
          this.idxActive = '4'
        break;
        default :
          this.idxActive = '1'
        break;
      }
      this.active = item
    },
    setItem2(idx) {
      switch (idx) {
        case '1':
          this.active = 'projects'
        break;
        case "2":
          this.active = 'roles'
        break;
        case "3":
          this.active = 'users'
        break;
        case "4":
          this.active = 'configurations'
        break;
        default :
          this.active = 'projects'
        break;
      }
    },
    isActive: function (l) {
      return this.active === l
    }
  }
};
</script>
<style>
</style>